<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <!--<div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">-->
                        <!--1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})-->
                        <!--</div>-->
                    </div>
                    <div class="card-body">
                        <div class="row ">
                            <div class="col col-12">
                              <div class="col col-12 text-center font-weight-bold">Минтақалар гуруҳлари:</div>
                              <div class="col col-12 px-0">
                                <GroupProvincesVue v-model="result.groupProvinces" :key2="result.year"></GroupProvincesVue>
                              </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12 table-responsive">
                                <!--<button class="all-btn add-btn pull-right" @click="addColumn">Қўшиш</button>-->
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table" style="min-width: 1050px;">
                                      <tr>
                                          <th class="text-center" style="width: 10%">Асосий фондларнинг гуруҳлари ва кодлари</th>
                                          <th class="text-center">
                                              <template>{{result.headerData['1995'].value}}</template>
                                          </th>

                                          <th class="text-center">
                                              <template>{{result.headerData['1996-2005'].value}}</template>
                                          </th>

                                          <th class="text-center position-relative">
                                              <template>
                                                  <div class="form-group">
                                                      <custom-date-picker
                                                              class="form-control"
                                                              :format="'yyyy'"
                                                              :minimumView="'year'"
                                                              v-model="result.headerData['2006-NEXT_YEAR'].startDate"
                                                              :date="result.headerData['2006-NEXT_YEAR'].startDate"
                                                              :clear-button="true">
                                                      </custom-date-picker>
                                                      <custom-date-picker
                                                              class="form-control"
                                                              :format="'yyyy'"
                                                              :minimumView="'year'"
                                                              v-model="result.headerData['2006-NEXT_YEAR'].endDate"
                                                              :date="result.headerData['2006-NEXT_YEAR'].endDate"
                                                              :clear-button="true">
                                                      </custom-date-picker>
                                                  </div>
                                              </template>
                                          </th>

                                          <th class="text-center position-relative">
                                              <template>
                                                  <div class="form-group">
                                                      <custom-date-picker
                                                              class="form-control"
                                                              :format="'yyyy'"
                                                              :minimumView="'year'"
                                                              v-model="result.headerData['PENULTIMATE_YEAR'].startDate"
                                                              :date="result.headerData['PENULTIMATE_YEAR'].startDate"
                                                              :clear-button="true">
                                                      </custom-date-picker>
                                                  </div>
                                              </template>
                                          </th>

                                          <th class="text-center position-relative" colspan="4">
                                              <template>
                                                  <div class="form-group" style="margin-top: 23px;">
                                                      <custom-date-picker
                                                              class="form-control w-25"
                                                              :format="'yyyy'"
                                                              :minimumView="'year'"
                                                              v-model="result.headerData['LAST_YEAR_WITH_QUARTERS'].startDate"
                                                              :date="result.headerData['LAST_YEAR_WITH_QUARTERS'].startDate"
                                                              :clear-button="true">
                                                      </custom-date-picker>
                                                  </div>
                                                  <div class="row">
                                                      <div class="col-sm-3">
                                                          {{result.headerData['LAST_YEAR_WITH_QUARTERS'].QUARTER1}}
                                                      </div>
                                                      <div class="col-sm-3">
                                                          {{result.headerData['LAST_YEAR_WITH_QUARTERS'].QUARTER2}}
                                                      </div>
                                                      <div class="col-sm-3">
                                                          {{result.headerData['LAST_YEAR_WITH_QUARTERS'].QUARTER3}}
                                                      </div>
                                                      <div class="col-sm-3">
                                                          {{result.headerData['LAST_YEAR_WITH_QUARTERS'].QUARTER4}}
                                                      </div>
                                                  </div>
                                              </template>
                                          </th>

                                          <th class="text-center position-relative" colspan="4">
                                              <template>
                                                  Амортизация
                                              </template>
                                          </th>
                                      </tr>
                                      <!--todo 10000-10018 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">1.{{result.data['INDEX_10000_10018'].text}}</td>
                                      </tr>
                                      <!--todo M-1-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_10000_10018']['INDEX_10000_10018_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-2-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_10000_10018']['INDEX_10000_10018_M2'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M2'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-3-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_10000_10018']['INDEX_10000_10018_M3'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M3'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-4-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_10000_10018']['INDEX_10000_10018_M4'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M4'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-5-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_10000_10018']['INDEX_10000_10018_M5'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_10000_10018']['INDEX_10000_10018_M5'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 20000-20382 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">2.{{result.data['INDEX_20000_20382'].text}}</td>
                                      </tr>
                                      <!--todo M-1-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_20000_20382']['INDEX_20000_20382_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-2-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_20000_20382']['INDEX_20000_20382_M2'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M2'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-3-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_20000_20382']['INDEX_20000_20382_M3'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M3'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-4-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_20000_20382']['INDEX_20000_20382_M4'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M4'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M-5-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_20000_20382']['INDEX_20000_20382_M5'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_20000_20382']['INDEX_20000_20382_M5'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 30000-30124 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">3.{{result.data['INDEX_30000_30124'].text}}</td>
                                      </tr>
                                      <!--todo M-1-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_30000_30124']['INDEX_30000_30124_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_30000_30124']['INDEX_30000_30124_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 40000-49303 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">4.{{result.data['INDEX_40000_49303'].text}}</td>
                                      </tr>
                                      <!--todo 4.1-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              4.1 {{result.data['INDEX_40000_49303']['INDEX_40000_40719'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_40000_40719'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo 4.2-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              4.2 {{result.data['INDEX_40000_49303']['INDEX_41000_46119'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_41000_46119'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo 4.3-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              4.3 {{result.data['INDEX_40000_49303']['INDEX_47000_47066'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_47000_47066'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo M.4-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              4.4 {{result.data['INDEX_40000_49303']['INDEX_48000_48010'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_48000_48010'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo 4.5-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              4.5 {{result.data['INDEX_40000_49303']['INDEX_49000_49303'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_40000_49303']['INDEX_49000_49303'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 50000-50709 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">5.{{result.data['INDEX_50000_50709'].text}}</td>
                                      </tr>
                                      <!--todo 5.1-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              5.1 {{result.data['INDEX_50000_50709']['INDEX_50000_50302'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50000_50302'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              5.2 {{result.data['INDEX_50000_50709']['INDEX_50400_50414'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50400_50414'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              5.3 {{result.data['INDEX_50000_50709']['INDEX_50415_50419'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50415_50419'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              5.4 {{result.data['INDEX_50000_50709']['INDEX_50600_50600'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50600_50600'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>
                                      <!--todo 5.2-->
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              5.5 {{result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_50000_50709']['INDEX_50420_50599_50601_50709'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 60000-60002 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">6.{{result.data['INDEX_60000_60002'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_60000_60002']['INDEX_60000_60002_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_60000_60002']['INDEX_60000_60002_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 70000-70002 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">7.{{result.data['INDEX_70000_70002_70005_70012'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70000_70002_70005_70012']['INDEX_70000_70002_70005_70012_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 70003-70004 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">8.{{result.data['INDEX_70003_70004'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_70003_70004']['INDEX_70003_70004_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_70003_70004']['INDEX_70003_70004_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 80000 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">9.{{result.data['INDEX_80000'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_80000']['INDEX_80000_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_80000']['INDEX_80000_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo 90000-90021 -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">10.{{result.data['INDEX_90000_90021'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_90000_90021']['INDEX_90000_90021_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_90000_90021']['INDEX_90000_90021_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo UNFINISHED_CONSTRUCTION_PROJECTS -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">11.{{result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS']['INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo OTHER_FIXED_ASSETS -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">12.{{result.data['INDEX_OTHER_FIXED_ASSETS'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_OTHER_FIXED_ASSETS']['INDEX_OTHER_FIXED_ASSETS_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo LIBRARY_FUNDS -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">13.{{result.data['INDEX_LIBRARY_FUNDS'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_LIBRARY_FUNDS']['INDEX_LIBRARY_FUNDS_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                      <!--todo UNINSTALLED_EQUIPMENT -->
                                      <tr class="bold-row">
                                          <td class="text-center" :colspan="9">14.{{result.data['INDEX_UNINSTALLED_EQUIPMENT'].text}}</td>
                                      </tr>
                                      <tr>
                                          <td class="text-center position-relative" style="width: 10%">
                                              {{result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1'].text}}
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['1995']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['1996-2005']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['2006-NEXT_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['PENULTIMATE_YEAR']" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER1" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER2" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER3" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1']['LAST_YEAR_WITH_QUARTERS'].QUARTER4" :precision="3" align="center"/>
                                          </td>
                                          <td class="text-center position-relative" style="width: 10%">
                                              <numeric-input v-model="result.data['INDEX_UNINSTALLED_EQUIPMENT']['INDEX_UNINSTALLED_EQUIPMENT_M1'].amortisation" :precision="3" align="center"/>
                                          </td>
                                      </tr>

                                  </table>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker';
    // import Treeselect from '@riophae/vue-treeselect';
    import {formatDate, parseDate} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import GroupProvincesVue from '@/views/config/re-evaluate/GroupProvincesVue';
    // import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';

    export default {
        name: "ProductionAndNonProduction",
        components: {
            CustomDatePicker,
            GroupProvincesVue
            // Treeselect
        },
        props: {
            date: String
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                businessId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                name: '',
                region: null,
                index: 3,
                result: {
                    id: null,
                    year: this.$props.date,
                    groupProvinces: [],
                    headerData: {
                        '1995': {code: '1995', value: '1995 йилгача (1995 йил хам киради)', startDate: '01/01/1995', endDate: '01/01/1995'},
                        '1996-2005': {code: '1996-2005', value: '1996-2005 йй', startDate: '01/01/1996', endDate: '01/01/2005'},
                        '2006-NEXT_YEAR': {code: '2006-NEXT_YEAR', value: null, startDate: '01/01/2006', endDate: null},
                        'PENULTIMATE_YEAR': {code: 'PENULTIMATE_YEAR', value: null, startDate: null},
                        'LAST_YEAR_WITH_QUARTERS': {
                            startDate: null,
                            value: null,
                            QUARTER1: 'I чорак',
                            QUARTER2: 'II чорак',
                            QUARTER3: 'III чорак',
                            QUARTER4: 'IV чорак'
                        },
                        amortisation: 'Амортизация'
                    },
                    data: {
                        'INDEX_10000_10018': {
                            text: 'Ишлаб чиқариш ва ноишлаб чиқариш бинолари (10000-10018)',
                            'INDEX_10000_10018_M1': {
                                text: 'М-1 гуруҳи',
                                "1995": 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_10000_10018_M2': {
                                text: 'М-2 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_10000_10018_M3': {
                                text: 'М-3 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_10000_10018_M4': {
                                text: 'М-4 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_10000_10018_M5': {
                                text: 'М-5 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_20000_20382': {
                            text: 'Иншоотлар (20000-20382)',
                            'INDEX_20000_20382_M1': {
                                text: 'М-1 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_20000_20382_M2': {
                                text: 'М-2 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_20000_20382_M3': {
                                text: 'М-3 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_20000_20382_M4': {
                                text: 'М-4 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_20000_20382_M5': {
                                text: 'М-5 гуруҳи',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_30000_30124': {
                            text: 'Узатиш қурилмалари (30000-30124)',
                            'INDEX_30000_30124_M1': {
                                text: '(30000-30124)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_40000_49303': {
                            text: 'Машиналар ва ускуналар (40000-49303)',
                            'INDEX_40000_40719': {
                                text: 'Куч машиналари ва ускуналар (40000-40719)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_41000_46119': {
                                text: 'Ишчи машиналар ва ускуналар (41000-46119)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_47000_47066': {
                                text: 'Ўлчов ва бошқарув асбоб ва қурилмалари, лаборатория жиҳозлари (47000-47066)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_48000_48010': {
                                text: 'Ҳисоблаш техникаси (48000-48010)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_49000_49303': {
                                text: 'Бошқа машина ва ускуналар (49000-49303)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_50000_50709': {
                            text: 'Транспорт воситалари (50000-50709)',
                            'INDEX_50000_50302': {
                                text: 'Бошқа транспорт воситалари (50000-50302)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_50400_50414': {
                                text: 'Бошқа транспорт воситалари (50400-50414)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_50415_50419': {
                                text: 'Енгил автомобиллар (50415-50419)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_50600_50600': {
                                text: 'Бошқа транспорт воситалари (50600)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            },
                            'INDEX_50420_50599_50601_50709': {
                                text: 'Бошқа транспорт воситалари (50420-50599, 50601-50709)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_60000_60002': {
                            text: 'Асбоб-ускуналар (60000-60002)',
                            'INDEX_60000_60002_M1': {
                                text: '(60000-60002)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_70000_70002_70005_70012': {
                            text: 'Ишлаб чиқариш ва хўжалик анжомлари, мебелсиз (70000-70002,70005-70012)',
                            'INDEX_70000_70002_70005_70012_M1': {
                                text: '(70000-70002,70005-70012)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_70003_70004': {
                            text: 'Мебель (70003-70004)',
                            'INDEX_70003_70004_M1': {
                                text: '(70003-70004)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_80000': {
                            text: 'Ишчи ва маҳсулдор моллар (80000)',
                            'INDEX_80000_M1': {
                                text: '(80000)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_90000_90021': {
                            text: 'Кўп йиллик кўчатлар (90000-90021)',
                            'INDEX_90000_90021_M1': {
                                text: '(90000-90021)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_UNFINISHED_CONSTRUCTION_PROJECTS': {
                            text: 'Қурилиши тугалланмаган объектлар',
                            'INDEX_UNFINISHED_CONSTRUCTION_PROJECTS_M1': {
                                text: '',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_OTHER_FIXED_ASSETS': {
                            text: 'Бошқа асосий фондлар (100000-110001)',
                            'INDEX_OTHER_FIXED_ASSETS_M1': {
                                text: '(100000-110001)',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_LIBRARY_FUNDS': {
                            text: 'Кутубхона фондлари',
                            'INDEX_LIBRARY_FUNDS_M1': {
                                text: '',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        },
                        'INDEX_UNINSTALLED_EQUIPMENT': {
                            text: 'Ўрнатилмаган ускуналар',
                            'INDEX_UNINSTALLED_EQUIPMENT_M1': {
                                text: '',
                                '1995': 0,
                                '1996-2005': 0,
                                '2006-NEXT_YEAR': 0,
                                'PENULTIMATE_YEAR': 0,
                                'LAST_YEAR_WITH_QUARTERS': {
                                    QUARTER1: 0,
                                    QUARTER2: 0,
                                    QUARTER3: 0,
                                    QUARTER4: 0
                                },
                                amortisation: 0
                            }
                        }
                    }
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                createDate: null,
                sectionResId: null,
                sectionType: null,
                maxMadeYear: new Date().getFullYear()
            }
        },
        validations() {
            return {
            }
        },
        computed: {
            // calculated() {
            //
            // },
        },
        methods: {
            init() {
                const vm = this;
                var startDate = parseDate(this.result.year);
                startDate = formatDate(startDate);
                const data = {
                    year: startDate
                };

                this.$http.post('re-evaluate-index/getByYear',  data)
                    .then(res => {
                        if (res.data && res.data.data) {
                            vm.result = res.data.data;
                            vm.result.year = res.data.year;
                            vm.result.id = res.data.id;

                            console.log(vm.result);
                            this.$eventBus.$emit('groupProvinces'+this.result.year, vm.result.groupProvinces);
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'business/edit/' + this.businessId);
            },
            save() {
                // this.$v.$touch();
                // if (this.$v.$invalid) {
                //     return;
                // }

                // console.log(this.result);
                this.processing = true;
                this.$http.post('re-evaluate-index/save', {id: this.result.id, year: this.result.year, data: {headerData: this.result.headerData, data: this.result.data, groupProvinces: this.result.groupProvinces}})
                    .then(res => {
                        if (res && res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('business.financeResult.success'),
                                type: 'success'
                            });
                            this.$router.push("/config/re-evaluate");
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            addColumn() {
                if (this.index > 4) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: 'Охирги 5 йил киритилади',
                        type: 'warning'
                    });
                    return;
                }
                this.index += 1;
                // for (const key in this.result) {
                //     console.log(key);
                //     if (!(key === "groupProvinces" || key === "periods") ) {
                //         this.result[key].indexs.push({
                //             index: 0
                //         });
                //     }
                // }
                // if (!this.result.periods){
                //     this.result.periods = [];
                // }

            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
